import React, { createContext } from 'react';
import PropTypes from 'prop-types';

export const ConfigContext = createContext();

const ConfigProvider = ({ config, children }) => (
    <ConfigContext.Provider value={ config }>
        {children}
    </ConfigContext.Provider>
);

ConfigProvider.propTypes = {
    config: PropTypes.shape({}),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export default ConfigProvider;
